import { useEffect, useState } from 'react';
import { resolveMediaUrl } from '../utils/mediaApi';

export function useResolvedMediaUrl(input?: string | null, refreshToken?: number): string {
  const [url, setUrl] = useState<string>('');

  useEffect(() => {
    let cancelled = false;
    const src = input || '';

    if (!src) {
      setUrl('');
      return () => {
        cancelled = true;
      };
    }

    resolveMediaUrl(src)
      .then((resolved) => {
        if (!cancelled) setUrl(resolved);
      })
      .catch(() => {
        if (!cancelled) setUrl(src);
      });

    return () => {
      cancelled = true;
    };
  }, [input, refreshToken]);

  return url;
}
